import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../core/auth/auth.service";
import {ActivatedRoute} from "@angular/router";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-handle-token',
  templateUrl: './handle-token.component.html',
  styleUrls: ['./handle-token.component.css']
})
export class HandleTokenComponent implements OnInit {

  token: any;
  modePro:boolean;
  logginFinish:boolean = false;

  constructor(private authService: AuthService, private route: ActivatedRoute ) {
    this.modePro = environment.pro;
    this.route.params.subscribe(params => {
      if (params['token']) {
        this.token = params['token'];
        this.loginWithToken(params['token'])
      }
    });
  }

  ngOnInit(): void {}

  loginWithToken(token) {
    this.authService.loginWithToken(token).then((res) => {
      this.logginFinish = true;
      if(res != 'failed') {
        let  user = this.authService.getUser();
        if(user.is_manager) {
          this.authService.setDestination('/manage/managerevents');
        }
        if(this.modePro && this.authService.UserHasNotOrganisation(user)) {
          this.authService.isProSignupProcessgoin = true;
          this.authService.setDestination('/login/signup');
        } else if (this.modePro && ( user.role_id == 1 || user.isOrga || user.events.length > 0)) {
          this.authService.setDestination('/manage/organization');
        }
        this.authService.redirect();
      } else {
        this.authService.setDestination('/login/signin');
        this.authService.redirect();
      }
    }).catch(error => {
      this.authService.setDestination('/login/signin');
      this.authService.redirect();
    });
  }

}
